import { IPropertyBag } from 'app/extensibility/property-bag';
import { BooleanDataFlowType, DecimalDataFlowType, DoubleDataFlowType, FloatDataFlowType, IntegerDataFlowType, LongDataFlowType, NumberDataFlowType, ShortDataFlowType } from 'app/model/dataflow/dataflow-datatype';
import { DataFlowExpression } from 'app/model/dataflow/dataflowexpression';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getValue(propertyBag: IPropertyBag, key: string): any {
    return getValueStrictly(propertyBag, key).value;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getValueStrictly(propertyBag: IPropertyBag, key: string, isDataFlowExpression?: boolean): { existing: boolean; value: any; } {
    const paths = key.split('.');
    let obj = propertyBag || {};

    let index = 0;
    let dataFlowExpression: DataFlowExpression;
    for (const path of paths) {
        if (isDataFlowExpression && index === paths.length - 2 && path in obj) {
            dataFlowExpression = obj[path];
        }
        if (index === paths.length - 1) {
            if (path in obj) {
                if (dataFlowExpression) {
                    let value;
                    switch (dataFlowExpression.requiredReturnType) {
                        case ShortDataFlowType.TYPE:
                        case DoubleDataFlowType.TYPE:
                        case FloatDataFlowType.TYPE:
                        case LongDataFlowType.TYPE:
                        case DecimalDataFlowType.TYPE:
                        case NumberDataFlowType.TYPE:
                        case IntegerDataFlowType.TYPE:
                            value = obj[path] && Number(obj[path]);
                            break;
                        case BooleanDataFlowType.TYPE:
                            value = obj[path] === 'true';
                            break;
                        default:
                            value = obj[path];
                    }
                    return {
                        existing: true,
                        value
                    };
                }
                return {
                    existing: true,
                    value: obj[path]
                };
            } else {
                return {
                    existing: false,
                    value: undefined
                };
            }
        } else {
            if (obj[path] == null) {
                return {
                    existing: false,
                    value: undefined
                };
            }

            obj = obj[path];
        }

        ++index;
    }

    throw new Error('This line should not be hit.');
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setValue(propertyBag: IPropertyBag, key: string, value: any, isDataFlowExpression?: boolean): void {
    const paths = key.split('.');
    let obj = propertyBag;

    let index = 0;
    for (const path of paths) {
        if (index === paths.length - 1) {
            obj[path] = isDataFlowExpression ? value && value.toString() : value;
        } else {
            if (obj[path] == null) {
                obj[path] = {};
            }

            obj = obj[path];
        }

        ++index;
    }
}
